import React, { useEffect, useState } from "react"
import { Progress } from "reactstrap"
import axios from "axios"

const ProgressBar = ({
  batchID,
  setLayout,
  setStatusResults,
  setBatchDetails,
}) => {
  const [progress, setProgress] = useState(0)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    let interval

    const simulateProgress = () => {
      interval = setInterval(() => {
        setProgress(prev => {
          if (prev >= 95) return prev // stop growing until response
          return prev + 1
        })
      }, 50)
    }

    setStatusResults([])

    const fetchData = async () => {
      simulateProgress()

      const formData = {
        PerToken: localStorage.getItem("token"),
        PerUserID: localStorage.getItem("id"),
        PerRoleID: localStorage.getItem("userRoleID"),
        BatchID: batchID,
      }

      if (batchID) {
        axios
          .post(
            process.env.REACT_APP_API_URL + `api/BaladyDetails/View.php`,
            formData
          )
          .then(res => {
            if (
              res.data.error === true &&
              res.data.message === "Access denied!"
            ) {
              setAuth(true)
              setTimeout(() => {
                history.push("/logout")
                setTimeout(() => {
                  history.push("/login")
                }, 1000)
              }, 4000)
            }

            // console.log("res.data", res.data)
            setBatchDetails(res.data.BatchDetails)

            let arrayKeys = Object.keys(res.data.StatusResults)
            // console.log("arrayKeys", arrayKeys)

            let results = arrayKeys.map(key => ({
              name: key,
              results: res.data.StatusResults[key],
            }))

            results = results.filter(result => result.results.length > 0)

            // console.log("results", results)

            setStatusResults(results)
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {
            setProgress(100)
            setIsLoading(false)
            setTimeout(() => {
              setLayout("results")
            }, [1000])
          })
      }
    }

    fetchData()

    return () => clearInterval(interval) // cleanup
  }, [batchID])

  return (
    <div className="my-5 py-5">
      <Progress
        style={{
          height: "20px",
        }}
        animated={isLoading}
        max="100"
        value={progress}
      >
        {progress}%
      </Progress>
    </div>
  )
}

export default ProgressBar
